
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_ig8mp_1mfpf_93",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_ig8mp_1mfpf_1",
  "tutorial-list": "awsui_tutorial-list_ig8mp_1mfpf_119",
  "tutorial-box": "awsui_tutorial-box_ig8mp_1mfpf_156",
  "tutorial-box-title": "awsui_tutorial-box-title_ig8mp_1mfpf_198",
  "tutorial-description-plaintext": "awsui_tutorial-description-plaintext_ig8mp_1mfpf_204",
  "tutorial-description": "awsui_tutorial-description_ig8mp_1mfpf_204",
  "expandable-section": "awsui_expandable-section_ig8mp_1mfpf_216",
  "expanded": "awsui_expanded_ig8mp_1mfpf_220",
  "button-wrapper": "awsui_button-wrapper_ig8mp_1mfpf_224",
  "start": "awsui_start_ig8mp_1mfpf_228",
  "expand-button": "awsui_expand-button_ig8mp_1mfpf_232",
  "collapse-button": "awsui_collapse-button_ig8mp_1mfpf_236",
  "learn-more-link": "awsui_learn-more-link_ig8mp_1mfpf_240",
  "title": "awsui_title_ig8mp_1mfpf_244",
  "prerequisites-alert": "awsui_prerequisites-alert_ig8mp_1mfpf_248",
  "completed": "awsui_completed_ig8mp_1mfpf_252",
  "download-link": "awsui_download-link_ig8mp_1mfpf_256"
};
  